import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import './About.css';

const About = () => (
  <>
    <Helmet>
      <title>About Us - Helvion Solutions</title>
      <meta name="description" content="Learn about Helvion Solutions - IT company providing software development, cloud services, and managed IT solutions." />
    </Helmet>
    <main className="about-page">
      <section className="about-hero">
        <div className="about-hero-content">
          <h1>About Helvion Solutions</h1>
          <p className="about-hero-subtitle">Empowering businesses through innovative technology solutions</p>
        </div>
      </section>
      <section className="section about-content">
        <div className="about-text">
          <h2>Who We Are</h2>
          <p>Helvion Solutions is a leading IT company dedicated to delivering cutting-edge technology solutions that drive business transformation. With a team of experienced professionals and a passion for innovation, we help businesses navigate the digital landscape and achieve their strategic objectives.</p>
          <p>Our commitment to excellence, combined with deep technical expertise, enables us to deliver solutions that are not just functional, but transformative.</p>
        </div>
        <div className="about-expertise">
          <h2>Our Expertise</h2>
          <p>With years of experience in the IT industry, our team brings deep expertise across multiple domains. From custom software development to cloud infrastructure, from mobile applications to DevOps automation, we have the knowledge and skills to tackle complex challenges and deliver solutions that make a difference.</p>
        </div>
        <div className="about-cta">
          <h2>Let's Work Together</h2>
          <p>Whether you're looking to build a new application, migrate to the cloud, or enhance your existing systems, we're here to help.</p>
          <div className="about-cta-buttons">
            <Link to="/contact" className="btn btn-primary">Contact Us</Link>
            <Link to="/services" className="btn btn-secondary">View Our Services</Link>
          </div>
        </div>
      </section>
    </main>
  </>
);

export default About;
